import * as actionTypes from "../actionTypes";

const initialState = {
    yatraData: [],
};

const yatraReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_YATRA: {
            return {
                ...state,
                yatraData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default yatraReducer;
